import L from "leaflet";
import type { ParcelSimpleStatus } from "../types";

// Kolorystyka statusu pozyskania (deklaracje własnej firmy) — spójna z legendą.
export const PARCEL_STYLE: Record<ParcelSimpleStatus, L.PathOptions> = {
  to_acquire: { color: "#6b7280", weight: 1.4, fillColor: "#ffffff", fillOpacity: 0.35 },
  acquired: { color: "#1f7a3d", weight: 1.4, fillColor: "#4caf7d", fillOpacity: 0.35 },
  problem: { color: "#b45309", weight: 1.6, fillColor: "#f59e0b", fillOpacity: 0.35 },
};

// Stan „planowane" i profil geodety: jednolity obrys, bez statusów.
export const PLAIN_PARCEL_STYLE: L.PathOptions = {
  color: "#6b7280",
  weight: 1.2,
  fillColor: "#9ca3af",
  fillOpacity: 0.18,
};

export const ROUTE_STYLE: L.PathOptions = { color: "#c8102e", weight: 3.5 };

export const STATUS_LABEL: Record<ParcelSimpleStatus, string> = {
  to_acquire: "Do pozyskania",
  acquired: "Zgoda pozyskana",
  problem: "Problem / odmowa",
};

export const DECLARED_STATUS_LABEL: Record<string, string> = {
  not_started: "Nie rozpoczęto",
  in_progress: "W trakcie",
  collected_in_field: "Zebrano w terenie",
  problem_refusal: "Problem (odmowa / żądania)",
  problem_impossible: "Problem (niemożliwe zebranie podpisu)",
  consent_written: "Pozyskano zgodę pisemną",
  decision_art124: "Pozyskano decyzję art. 124",
};

export const SCOPE_LABEL: Record<string, string> = {
  wpw: "Zgody (WPW)",
  mdcp_geodezja: "Geodezja (MDCP)",
};

// Pin megamapy: kwadrat w stylu aplikacji (zero zaokrągleń) — pełny = zlecone,
// konturowy = planowane. divIcon zamiast obrazka: brak zależności od assetów Leafleta.
export function projectPin(state: "ordered" | "planned", label: string): L.DivIcon {
  const fill = state === "ordered" ? "#c8102e" : "#ffffff";
  const border = "#c8102e";
  // Bez pointer-events:none i z realnym boxem — pin MUSI łapać klik (nawigacja
  // do projektu); zdarzenia z dzieci bąbelkują do elementu markera Leafleta.
  return L.divIcon({
    className: "",
    html:
      `<div style="display:flex;flex-direction:column;align-items:center;cursor:pointer">` +
      `<span style="background:#1c1c20;color:#fff;font:600 10px/1.4 ui-monospace,monospace;` +
      `padding:1px 5px;white-space:nowrap;margin-bottom:2px">${escapeHtml(label)}</span>` +
      `<span style="width:14px;height:14px;background:${fill};border:2.5px solid ${border};` +
      `box-shadow:0 1px 4px rgba(0,0,0,.4)"></span></div>`,
    // Realna zawartość: etykieta ~18px + odstęp 2px + kwadrat 19px (14 + 2×2,5
    // obrysu) — kotwica na dole kwadratu, żeby pin wskazywał dokładnie centroid.
    iconSize: [20, 39],
    iconAnchor: [10, 39],
  });
}

export function escapeHtml(raw: string): string {
  return raw
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

/** Polska liczba mnoga: 1 projekt, 2–4 projekty (poza 12–14), reszta projektów. */
export function projectsPlural(count: number): string {
  if (count === 1) return "projekt";
  const tens = count % 100;
  const ones = count % 10;
  if (ones >= 2 && ones <= 4 && (tens < 12 || tens > 14)) return "projekty";
  return "projektów";
}

export function monthLabel(month: string | null): string {
  if (!month) return "";
  const [year, mm] = month.split("-");
  const names = [
    "styczeń", "luty", "marzec", "kwiecień", "maj", "czerwiec",
    "lipiec", "sierpień", "wrzesień", "październik", "listopad", "grudzień",
  ];
  const index = Number(mm) - 1;
  return names[index] ? `${names[index]} ${year}` : month;
}
